export type ParameterValueType =
	| 'ARI'
	| 'STRING'
	| 'INTEGER'
	| 'FLOAT'
	| 'BOOLEAN'
	| 'JSON'
	| 'DATETIME'
	| 'LIST';

export function parseParameterValue(value: string, type: ParameterValueType = 'STRING'): unknown {
	if (type === 'STRING' || type === 'ARI' || type === 'DATETIME') return value;
	let parsed: unknown;
	try {
		parsed = JSON.parse(value);
	} catch {
		throw new Error('Enter a valid JSON value.');
	}
	if (type === 'INTEGER' && (typeof parsed !== 'number' || !Number.isSafeInteger(parsed))) {
		throw new Error('Enter a whole number.');
	}
	if (type === 'FLOAT' && (typeof parsed !== 'number' || !Number.isFinite(parsed))) {
		throw new Error('Enter a finite number.');
	}
	if (type === 'BOOLEAN' && typeof parsed !== 'boolean') {
		throw new Error('Enter true or false.');
	}
	if (type === 'LIST' && !Array.isArray(parsed)) {
		throw new Error('Enter a JSON list, such as [1, 2].');
	}
	return parsed;
}

export function parameterValueType(value: unknown): ParameterValueType {
	if (typeof value === 'string') return 'STRING';
	if (typeof value === 'number') return Number.isInteger(value) ? 'INTEGER' : 'FLOAT';
	if (typeof value === 'boolean') return 'BOOLEAN';
	return Array.isArray(value) ? 'LIST' : 'JSON';
}
